import { fetch } from '@/utils/http'

export default {
  //获取任务列表
  getList: params => fetch('get', '/cbaas-service/v1/crosschain/list', params), //跨链服务列表
  getRecordtList: params => fetch('get', '/cbaas-service/v1/crosschain/record', params), //跨链交易列表
  createCrossChain: params => fetch('post', '/cbaas-service/v1/crosschain/create', params), //跨链服务列表
  subscribeCrossChain: params => fetch('post', '/cbaas-service/v1/crosschain/subscribe', params), //订阅
  deliver: params => fetch('post', '/cbaas-service/v1/crosschain/deliver', params) //调用跨链服务
}
